// extracted by mini-css-extract-plugin
module.exports = {"facets":"FacetList-module_facets_1WUjw","topLevel":"FacetList-module_topLevel_2BFeG"};